export const state = () => {
	return {
		applications: [],
		count: 0,
	}
}

export const actions = {
	async list_paginate({ commit }, { companyId, params }) {
		const { limit, ...restParams } = params
		let searchUrl = `api/company/${companyId}/applications/?limit=${limit}`

		// Handle all array parameters dynamically
		for (const [key, value] of Object.entries(params)) {
			if (Array.isArray(value) && value.length > 0) {
				value.forEach((item) => {
					searchUrl += `&${key}[]=${encodeURIComponent(item)}`
				})
				// Remove this parameter from restParams to avoid duplication
				delete restParams[key]
			}
		}

		return await useNuxtApp()
			.$api(searchUrl, { params: restParams })
			.then((res) => {
				commit('set', res.results)
				return res
			})
	},

	async count({ commit }, { companyId, params }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/applications/`, { params })
			.then((res) => {
				commit('setCount', res.count)
				return res
			})
	},

	async get_page({ commit }, { pageURL }) {
		return await useNuxtApp()
			.$api(pageURL)
			.then((res) => {
				commit('set', res.results)
				return res
			})
	},

	async mass_create({ commit }, { companyId, applicationsIds, listsIds }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/creators/create-from-application/`, {
				method: 'POST',
				body: {
					application_ids: applicationsIds,
					targeting_ids: listsIds,
				},
			})
			.then((res) => {
				commit('set', res.results)
				return res
			})
	},

	async massDeleteApplications(_, { companyId, applicationsIds }) {
		return await useNuxtApp().$api(`api/company/${companyId}/applications/mass-delete/`, {
			method: 'POST',
			body: {
				application_ids: applicationsIds,
			},
		})
	},

	async deleteAll(_, { companyId, campaignId }) {
		return await useNuxtApp().$api(
			`api/company/${companyId}/applications/mass-delete/?campaign=${campaignId}`,
			{ method: 'DELETE' },
		)
	},
}

export const mutations = {
	set(state, data) {
		state.applications = data
	},
	setCount(state, data) {
		state.count = data
	},
}
